import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ApiClientService } from "@shared/_services/api-client.service";
import { ToastrModule } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import Swal from "sweetalert2";
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';
import { ManageRegionComponent } from './manage-region/manage-region.component';

@Component({
  selector: 'app-regions-conf',
  standalone: true,
  imports: [CommonModule, ToastrModule, PreloaderComponent, ManageRegionComponent],
  providers: [
    ToastrService,
  ],
  templateUrl: './regions-conf.component.html',
  styleUrl: './regions-conf.component.css'
})
export class RegionsConfComponent {
  public loading: boolean = false;
  public hasError: boolean = false;
  public errorMsg: string = '';
  public regions: any = [];
  public selectedAction: string = 'view-all';
  public manageRegionData: any = {};

  constructor(private _apiClientService: ApiClientService, private _toastrService: ToastrService,) { }

  ngOnInit() {
    this.getAllRegions();
  }


  public async getAllRegions() {
    this.loading = true;
    (await this._apiClientService.readAllApiService(`select-option?q=region`)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("Regions Details ", event.body);
            let { status, error, message, data } = event.body;
            //if (status == 200) {

            this.regions = event.body.sort(this.compare);
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  private compare(a: any, b: any): any {
    const bandA = a.order;
    const bandB = b.order;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  
  public triggerDelete(region: any) {
    console.log(region);
    const self = this;
    Swal.fire({
      title: 'Delete Region',
      text: 'Do you want to delete this region?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#dc3545', // Green color for Yes button
      cancelButtonColor: '#9b9b9b',  // Red color for No button
    }).then((result: any) => {
      /* Read more about isConfirmed, isDenied below */
      console.log(result.isConfirmed);
      if (result.isConfirmed) {
        console.log(result);
        this.deleteRegion(region);
      }
    });
  }

  public async deleteRegion(region: any) {
    this.loading = true;
    (await this._apiClientService.addApiService(`admin/select-option/region/remove`, {
      "regionId": region.id
  } )).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("Region Deleted ", event.body);
            this._toastrService.success('Deleted Region Successfully', 'Success');
            let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.getAllRegions();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public selectRegionAction(action: string, data: any = ''): void {
    this.manageRegionData = [];
    switch (action) {
      case 'view-all':
      case 'cancel':
      case 'completed':
        this.selectedAction = 'view-all';
        this.getAllRegions();
        break;
      case 'add':
        this.selectedAction = 'manage-category';
        this.manageRegionData = { action: 'add' };
        break;
      case 'edit':
        this.selectedAction = 'manage-category';
        this.manageRegionData = { action: 'edit', data: data };
        break;
    }
  }

  public receiveRegionResponse($event: string) {
    console.log("Region Response ", $event);
    this.selectRegionAction($event);
  }

}
